import { render, staticRenderFns } from "./manufacture.vue?vue&type=template&id=770e05fa&scoped=true&"
import script from "./manufacture.vue?vue&type=script&lang=js&"
export * from "./manufacture.vue?vue&type=script&lang=js&"
import style0 from "./manufacture.vue?vue&type=style&index=0&id=770e05fa&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "770e05fa",
  null
  
)

export default component.exports